import { Env } from './env.types';
import { throwIfFalsy } from './throw';

throwIfFalsy(process.env.REACT_APP_API_URL, `'REACT_APP_API_URL' variable must be set`);

export const ENV: Env = {
    API_URL: process.env.REACT_APP_API_URL
};
